export const ORDER_RECAP = {
    ADD: "add-order-recap",
    REMOVE: "remove-order-recap",
    SELECTED_GROUP: "order-recap-selected-group",
    SAVE: "save-order-recaps",
    SPLIT_ROW: "order-recap-split-row",
    INCLUDE_IN_PDF: "order-recap-include-in-pdf",
};
